/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
console.log("CUSTOM JS ADDED");


class PopupQuickViewItem extends HTMLElement {
  connectedCallback() {
    const wrapper = this.querySelector('.popup-quick-view__wrapper');
    const soldOut = wrapper?.classList.contains('variant--soldout');

    const sizeSelected = this.querySelector(`[name*="Size"]:checked`);
    if (sizeSelected) {
      console.log({sizeSelected})
      this.querySelector(".submit-button--transparency")?.remove();
      setTimeout(() => {
        sizeSelected.click();
      }, 100);
    }

    if (soldOut) {
      this.querySelector(".quick-view-ATC")?.setAttribute("disabled", "disabled");
      this.querySelector(".submit-button--transparency")?.remove();
    }
  }
}

if (!customElements.get('popup-quick-view-item')) {
  customElements.define('popup-quick-view-item', PopupQuickViewItem);
} else {
  console.warn('[custom.js] popup-quick-view-item already defined by theme — skipping');
}


class PdpFormWrapper extends HTMLElement {
  connectedCallback() {
    console.log('[pdp-form-wrapper] connected', this)
    const isSoldOut = this.classList.contains('variant--soldout'); // cspell:ignore soldout
    console.log('[pdp-form-wrapper] sold out:', isSoldOut)

    if (isSoldOut) {
      this.querySelector('.quick-view-ATC')?.setAttribute('disabled', 'disabled');
      this.querySelector('.submit-button--transparency')?.remove();
    }
  }
}

if (!customElements.get('pdp-form-wrapper')) {
  customElements.define('pdp-form-wrapper', PdpFormWrapper);
} else {
  console.warn('[custom.js] pdp-form-wrapper already defined by theme — skipping');
}

(function () {
  var MIN_LENGTH = 4;

  // Listen globally because modal is dynamic
  document.addEventListener("click", function (e) {
    var nextBtn = e.target.closest(".jdgm-write-review-modal__nav-btn-next");
    if (!nextBtn) return;

    // Only validate on step 2 (review body page)
    var modal = e.target.closest(".jdgm-write-review-modal");
    if (!modal) return;

    var textarea = modal.querySelector("#jdgm-review-body-input");
    if (!textarea) return;

    var value = textarea.value.trim();
    var errorEl = modal.querySelector("#jdgm-review-body-error");

    if (value.length < MIN_LENGTH) {
      e.preventDefault();
      e.stopPropagation();

      if (errorEl) {
        errorEl.style.display = "block";
        errorEl.textContent =
          "Please write at least " + MIN_LENGTH + " characters.";
      }

      textarea.focus();
    } else {
      // clear error if valid
      if (errorEl) {
        errorEl.style.display = "none";
        errorEl.textContent = "";
      }
    }
  });
})();

(function () {
  window.addEventListener("load", function () {
    // hide empty sections
    document.querySelectorAll("section").forEach(section => {
      if(section.innerText == ''  && section.querySelector(".shopify-app-block") != null) {
        section.style.display = 'none'
      }
    })
  });
})();

['rebuy:cart.change', 'rebuy:cart.add'].forEach(function(event) {
  document.addEventListener(event, function() {
    if (typeof Rebuy !== 'undefined' && typeof Rebuy.reinit === 'function') {
      setTimeout(() => {
        Rebuy.reinit();
      }, 100);
    }
  });
});

// When the theme's native add-to-cart fires (e.g. quick buy on grid items),
// Rebuy doesn't get a rebuy:cart.add event, so we open it manually here.
document.addEventListener('theme:cart:added', function() {
  if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart) {
    setTimeout(function() {
      Rebuy.SmartCart.show();
      Rebuy.reinit();
    }, 300);
  }
});

// Allow touch-scrolling inside the Rebuy cart on mobile.
// The theme's scroll-lock library locks all touch scroll when any drawer opens.
// We exempt [data-rebuy-cart-scroll-area] via two paths:
//   1. scroll-lock v2 addScrollableSelector (permanent exemption)
//   2. stopPropagation on touchmove so the document-level lock listener never fires
(function () {
  if (window.themeVendor && window.themeVendor.ScrollLock) {
    window.themeVendor.ScrollLock.addScrollableSelector('[data-rebuy-cart-scroll-area]');
  }

  function attachRebuyScrollTouch() {
    var scrollArea = document.querySelector('[data-rebuy-cart-scroll-area]');
    if (!scrollArea || scrollArea._rebuyTouchBound) return;
    scrollArea._rebuyTouchBound = true;
    scrollArea.addEventListener('touchmove', function (e) {
      e.stopPropagation();
    }, { passive: true });
  }

  document.addEventListener('DOMContentLoaded', attachRebuyScrollTouch);
  document.addEventListener('rebuy:smartcart.ready', attachRebuyScrollTouch);
  document.addEventListener('rebuy:cart.show', function () {
    setTimeout(attachRebuyScrollTouch, 50);
  });
})();



(function () {
  function updateCartBadges(count) {
    document.querySelectorAll('.cart-count-badge').forEach(function (badge) {
      badge.textContent = count;
      badge.classList.toggle('hidden', count === 0);
    });
  }

  document.addEventListener('rebuy:cart.change', function (event) {
    var cart = event.detail && event.detail.cart;
    var count = cart && cart.cart && cart.cart.item_count;
    if (typeof count === 'number') updateCartBadges(count);
  });

  document.addEventListener('rebuy:cart.add', function (event) {
    var cart = event.detail && event.detail.cart;
    var count = cart && cart.cart && cart.cart.item_count;
    if (typeof count === 'number') updateCartBadges(count);
  });
})();

window.addEventListener("load", ()=>{
  document.querySelectorAll(".search-popdown__close").forEach(close => {
    close.addEventListener("click", () => {
      document.querySelector("#MainContent").click()
    })
  })
});
